import React, { useState } from 'react';
import { InputText, InputMoney, InputSelect } from '../../Inputs';

/**
 * Title Fees form for the residential calculator.
 **/
const ResidentialCalculatorTitleFeesForm = ({ formProps }) => {
  // options for the select dropdown input
  const selectOptions = [
    { value: '', label: 'Please Choose' },
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' }
  ];

  const selectOptionsWhoPays = [
    { value: '', label: 'Please Choose' },
    { value: 'buyer', label: 'Buyer' },
    { value: 'seller', label: 'Seller' }
  ];

  const { surveyAmendmentT1R, t19_1 } = formProps.values;

  return (
    <div className="grid">
      <div className="grid__col-xs-12">
        <InputText {...formProps} name="property" label="Property" />
      </div>
      <div className="grid__col-xs-12 grid__col-md-6">
        <InputMoney
          {...formProps}
          name="salesPrice"
          label="Sales Price"
          required={true}
        />
      </div>
      <div className="grid__col-xs-12 grid__col-md-6">
        <InputMoney
          {...formProps}
          name="loanAmount"
          label="Loan Amount"
          required={true}
        />
      </div>
      <div className="grid__col-xs-12">
        <InputSelect
          {...formProps}
          name="whoPaysOwnersPolicy"
          label="Who Pays for the Owner’s Policy?"
          required={true}
          options={selectOptionsWhoPays}
        />
      </div>
      <div className="grid__col-xs-12 grid__col-md-6">
        <div className="grid">
          <div className="grid__col-xs-12">
            <InputSelect
              {...formProps}
              name="surveyAmendmentT1R"
              label="Survey Amendment to T-1R Policy"
              required={true}
              options={selectOptions}
            />
          </div>
          <div className="grid__col-xs-12">
            {surveyAmendmentT1R === 'yes' && (
              <InputSelect
                {...formProps}
                name="whoPaysSurveyAmendmentT1R"
                label="Who Pays?"
                options={selectOptionsWhoPays}
              />
            )}
          </div>
        </div>
      </div>
      <div className="grid__col-xs-12 grid__col-md-6">
        <div className="grid">
          <div className="grid__col-xs-12">
            <InputSelect
              {...formProps}
              name="t19_1"
              label="T-19.1 (Rest/Encro/Minerals)"
              required={true}
              options={selectOptions}
            />
          </div>
          <div className="grid__col-xs-12">
            {t19_1 === 'yes' && (
              <InputSelect
                {...formProps}
                name="whoPaysT19_1"
                label="Who Pays?"
                options={selectOptionsWhoPays}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResidentialCalculatorTitleFeesForm;
